import { createContext } from 'react';

import type { NonProjectDalContextValue } from './nonProjectDalContextTypes';

export const NonProjectDalContext =
  createContext<NonProjectDalContextValue | null>(null);
